<template>
  <router-link exact tag="div" :to="to" class="menu-list" :id="id">
    <i :class="`fa fa-${icon}`"></i>
    <span v-if="getSideDrawer">{{ label }}</span>
    <div class="baar"></div>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["to", "label", "icon", "id"],
  computed: {
    ...mapGetters({
      getSideDrawer: "getSideDrawer"
    })
  }
};
</script>

<style scoped>
.menu-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 10px 15px;
  margin: 3px 0;
  position: relative;
  transition: all 0.3s ease;
  white-space: nowrap;
  height: 44px;
}
.fa {
  margin-right: 20px;
  color: var(--primary-color);
}
.active {
  background: rgba(85, 127, 112, 0.4);
  border-radius: 8px;
  transition: all 0.3s ease;
}
.active .baar {
  position: absolute;
  left: 0;
  width: 5px;
  height: 25px;
  background: var(--primary-color);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
